import { useTranslations } from "next-intl";
import { ReactNode } from "react";

function BindingRow({ text, value }: { text: string | ReactNode; value: number }) {
  return (
    <p className="mb-1 flex items-center justify-between">
      <span>{text}:</span>
      <span className="font-bold">{value}</span>
    </p>
  );
}

type BindingSettingsProps = {
  min: number;
  max: number;
  multiples: number;
};

export function BindingSettings({ min, max, multiples }: BindingSettingsProps) {
  const t = useTranslations("custom-attributes-forms");
  return (
    <>
      <div className="hidden text-sm md:flex md:flex-col md:text-base lg:hidden lg:text-sm 2xl:flex 2xl:text-base">
        <BindingRow text={t("text-min-pages")} value={min} />
        <BindingRow text={t("text-max-pages")} value={max} />
        <BindingRow
          text={t.rich("text-multiples", {
            must: (t) => <u>{t}</u>,
          })}
          value={multiples}
        />
      </div>
      <div className="flex flex-col text-sm md:hidden md:text-base lg:flex lg:text-sm 2xl:hidden 2xl:text-base">
        <BindingRow text={t("text-mobile-min-pages")} value={min} />
        <BindingRow text={t("text-mobile-max-pages")} value={max} />
        <BindingRow
          text={t.rich("text-mobile-multiples", {
            must: (t) => <u>{t}</u>,
          })}
          value={multiples}
        />
      </div>
    </>
  );
}
